<template>
  <div
    id="qr-code-wallet-modal"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-[310px] max-h-full">
      <div class="relative bg-gray-700 rounded-lg shadow">
        <div
          class="flex items-center justify-center px-2 py-1 border-b border-gray-600 rounded-t"
        >
          <h3 class="font-bold text-white text-lg">
            {{ this.wallet.name }}
          </h3>
        </div>
        <div
          class="px-6 pt-3 pb-1 flex flex-col gap-2 justify-center items-center"
        >
          <vue-qrcode
            :value="this.wallet.address"
            type="image/png"
            :color="{
              dark: '#ece5e5',
              light: '#374151',
            }"
            :quality="1"
            :width="300"
            :margin="0"
            :scale="4"
          ></vue-qrcode>
          <div class="text-sm">
            {{ this.shortAddress(this.wallet.address) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "flowbite";
import VueQrcode from "vue-qrcode";
import { mapGetters } from "vuex";

export default {
  name: "QRCodeWalletModal",
  components: { VueQrcode },
  data() {
    return {
      modal: null,
    };
  },
  computed: {
    ...mapGetters("network", ["shortAddress"]),
    open() {
      return this.$store.state.qrCodeWallet.open;
    },
    wallet() {
      return this.$store.state.qrCodeWallet.wallet;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.modal.show();
      }
    },
  },
  methods: {},
  mounted() {
    this.modal = new Modal(document.getElementById("qr-code-wallet-modal"), {
      placement: "center",
      backdropClasses:
        "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
      onHide: () => {
        this.$store.dispatch("qrCodeWallet/hide");
      },
    });
  },
  beforeUnmount() {
    this.$store.dispatch("qrCodeWallet/hide");
  },
};
</script>
